// extracted by mini-css-extract-plugin
export default {"list_wrapper":"style_list_wrapper__z8pC0","list_item":"style_list_item__LFFVT","logo_wrapper":"style_logo_wrapper__RIJbS","bank_detail_wrapper":"style_bank_detail_wrapper__5hPEf"};